import { render } from "./Proportiongradient.vue?vue&type=template&id=33963832"
import script from "./Proportiongradient.vue?vue&type=script&lang=js"
export * from "./Proportiongradient.vue?vue&type=script&lang=js"

import "./Proportiongradient.vue?vue&type=style&index=0&id=33963832&lang=css"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__